// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606261019/js/" + chunkId + "." + {"44":"5b1c42d0","225":"fa859654","481":"36ad1625","486":"fe529934","770":"6969dba1"}[chunkId] + ".0.20541210103064778.chunk.js";
};